import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  NbComponentStatus,
  NbDialogRef,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbTagComponent,
  NbTagInputAddEvent,
  NbToastrService,
} from "@nebular/theme";
import * as _ from "lodash";
import * as moment from "moment";
import { EMAIL_PATTERN } from "../../../@auth/components/constants";
import { User } from "../../../@core/data/users";
import { UserService } from "../../../@core/services/user.service";
import { Customer } from "../../../models/customer.model";
import Shop from "../../../models/shop.model";
import { CustomerService } from "../../../services/customer.service";
import { ShopService } from "../../../services/shop.service";

@Component({
  selector: "ngx-dialog-register",
  templateUrl: "dialog-register.component.html",
  styleUrls: ["dialog-register.component.scss"],
})
export class DialogRegisterComponent implements OnInit {
  @Input() header?: string;

  diaForm: FormGroup;
  submitted = false;
  loading = false;

  shop: Shop = {
    code: "",
    title: "",
    description: "",
    email: "",
    mobile: "",
    product: true,
    customer: true,
    warehouse: true,
    finance: true,
    receipt: true,
    purchase: true,
    working: true,
    trade: true,
    isPremium: false,
    expDate: moment().add(1, "months").endOf("day").toDate(),
  };
  user: User = {
    displayName: "",
    email: "",
    password: "",
    admin: false,
    moderator: true,
    product: true,
    customer: true,
    warehouse: true,
    finance: true,
    receipt: true,
    purchase: true,
    working: true,
    salesman: false,
    printReceiptA4: true,
    printReceiptPos: true,
    role: "",
    language: "",
    shopId: "",
  };

  constructor(
    protected ref: NbDialogRef<DialogRegisterComponent>,
    private fb: FormBuilder,
    private userService: UserService,
    private customerService: CustomerService,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService
  ) {}

  ngOnInit() {
    const emailValidators = [
      Validators.required,
      Validators.pattern(EMAIL_PATTERN),
    ];
    const passwordValidators = [
      Validators.required,
      Validators.minLength(6),
      Validators.maxLength(50),
    ];
    const mobileValidators = [
      Validators.required,
      Validators.minLength(9),
      Validators.maxLength(500),
    ];
    const stringValidators = [
      Validators.required,
      Validators.minLength(1),
      Validators.maxLength(500),
    ];

    this.diaForm = this.fb.group({
      title: ["", stringValidators],
      address: ["", stringValidators],
      description: [],
      displayName: ["", stringValidators],
      mobile: this.fb.control("", [...mobileValidators]),
      email: this.fb.control("", [...emailValidators]),
      password: this.fb.control("", [...passwordValidators]),
      purchase: [],
      finance: [],
      product: [],
      warehouse: [],
      customer: [],
      receipt: [],
      working: [],
      trade: [],
    });
  }

  cancel() {
    this.ref.close();
  }

  submit() {
    this.shop.title = this.shop.title ? this.shop.title : "";
    this.shop.address = this.shop.address ? this.shop.address : "";
    this.shop.mobile = this.shop.mobile
      ? this.shop.mobile.replace(" ", "").trim()
      : "";
    this.shop.description = this.shop.description ? this.shop.description : "";

    this.user.displayName = this.user.displayName
      ? this.user.displayName
      : "User";
    this.user.email = this.user.email
      ? this.user.email.replace(" ", "").trim()
      : "";
    this.user.password = this.user.password
      ? this.user.password.replace(" ", "").trim()
      : "";

    if (this.shop.trade) {
      this.shop.finance = true;
      this.shop.purchase = true;
    }

    if (!this.user.email && this.user.password) {
      this.showToast("danger", "Bắt buộc nhập email và mật khẩu", "");
    } else {
      this.submitted = true;
      this.loading = true;
      this.userService.register(this.shop, this.user).subscribe(
        (userRecord) => {
          console.log("selectedItem/userRecord:", userRecord);

          this.loading = false;
          this.showToast("success", "Tạo tài khoản", "thành công");

          //create customer
          let customer: Customer = {
            fullName: this.shop.title,
            mobile: this.shop.mobile,
            address: this.shop.address,
            description: this.shop.description,
            email: this.user.email,
          };
          this.customerService
            .create(customer)
            .then((data) => {
              customer = data;
              console.log("register/customer:", customer);
            })
            .catch((err) => {});

          this.ref.close(true);
        },
        (error) => {
          console.log(error);
          this.showToast("warning", "Tạo tài khoản", "thất bại");
          this.loading = false;
        }
      );
    }
  }

  // control event
  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 2000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };
    const titleContent = title ? `${title}` : "";

    this.toastrService.show(body, titleContent, config);
  }
}
